import { PAYMENT_SUCCESS } from '../../reducers/paymentSummaryReducers';

export const paymentSuccess = () => ({
  type: PAYMENT_SUCCESS,
});
